import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function getJobStatuses(jobId: string) {
	const response = await fetch(`${apiEndpoint}/jobs/${jobId}/statuses `, {
		method: 'GET',
		headers: await standardHeaders(),
		mode: 'cors'
	});
	if (response.ok) {
		return await response.json();
	}
	return null;
};